import { useEffect, useRef, useState } from "react";

interface PullQuoteProps {
  text: string;
  className?: string;
}

const PullQuote = ({ text, className = "" }: PullQuoteProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: "-60px" }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`relative py-12 md:py-16 px-6 text-center ${className}`}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(20px)",
        transition: "opacity 0.7s ease, transform 0.7s ease",
      }}
    >
      <span
        className="absolute top-0 left-1/2 -translate-x-1/2 text-[120px] md:text-[160px] leading-none font-serif text-gradient opacity-20 select-none pointer-events-none"
        aria-hidden="true"
      >
        &ldquo;
      </span>
      <p className="relative text-xl md:text-2xl lg:text-3xl font-light italic text-foreground/80 max-w-2xl mx-auto leading-relaxed">
        {text}
      </p>
    </div>
  );
};

export default PullQuote;
